var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineUsersBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34255 1C6.36028 1 5.00573 2.58465 5.3306 4.52115L5.82617 7.45317C6.02164 8.61506 7.15319 9.56695 8.34255 9.56695C9.53191 9.56695 10.6662 8.61779 10.8589 7.45317L11.3517 4.52115C11.6766 2.58465 10.3221 1 8.33979 1H8.34255Z",
    stroke: "#515151",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5207 10.9198L11.0738 9.78247C10.3497 10.4834 9.37508 10.9307 8.34265 10.9307C7.31022 10.9307 6.3356 10.4834 5.61153 9.78247L2.16183 10.9198C1.5231 11.1298 1 11.8499 1 12.5154V15.5456H15.6825V12.5154C15.6825 11.8499 15.1595 11.1298 14.5207 10.9198Z",
    stroke: "#515151",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3921 4.81121C15.5543 3.69639 17.4326 3.69639 18.5948 4.81121",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6758 3.16486C14.7839 1.14264 18.2028 1.14264 20.3244 3.16486",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.35198C16.7985 7.35198 17.0406 7.11983 17.0406 6.83346C17.0406 6.54709 16.7985 6.31494 16.5 6.31494C16.2015 6.31494 15.9595 6.54709 15.9595 6.83346C15.9595 7.11983 16.2015 7.35198 16.5 7.35198Z",
    stroke: "#515151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineUsersBlack);
export default __webpack_public_path__ + "static/media/OnlineUsersBlack.4efa011fd39d5050ee6f51a22eb79d53.svg";
export { ForwardRef as ReactComponent };